import { ErrorHandler } from '@angular/core';

export class AppErrorHandler implements ErrorHandler {
    handleError(error) {
        alert('An unexpected error occurred.');
        console.log(error);
    }
}


// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/app-error-handler.ts